import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import esMsgs from './locales/es.json';

const availableAppLocales = ['es'] as const;
export type AvailableLocales = (typeof availableAppLocales)[number];

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: esMsgs },
  },
  lng: 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export default i18n;
